import * as tslib_1 from "tslib";
import common from "../../../../../common/pc";
import { AggregateType, FormControlType } from "../../../../../form/schema";
import { FormRendererHelper } from "../../../../../form/src/renderer/components/form-renderer-helper";
import BaseControlAdapter from "../../../../../form/src/renderer/components/pc/base-control-adapter.vue";
import numberFilter from "../../../../../form/utils/number-filter";
import * as numberFormatter from "../../../../../form/utils/number-formatter";
import { Button, Checkbox, Divider, Dropdown, Icon, Menu, Popover, Tooltip } from "@h3/antd-vue";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import CheckboxText from "./checkbox-text.vue";
let Sheet = class Sheet extends Vue {
    constructor() {
        super(...arguments);
        this.shadowLeft = false;
        this.shadowRight = false;
        this.scrollbar = null;
        this.colStyles = [];
        this.sheetIsScroll = false; // 表格是否滚动
        this.mounteStartTime = 0;
        this.updateStartTime = 0;
        this.sheetBodyStyle = {};
    }
    get canFrozen() {
        return this.unFreezeColumns.length > 1;
    }
    get canUnFrozen() {
        return this.frozenKeys.length > 0;
    }
    get checkedAll() {
        return this.checkeds.length > 0 && this.checkeds.every((c) => c);
    }
    get indeterminate() {
        const checkeds = this.checkeds.filter((c) => c);
        return checkeds.length > 0 && checkeds.length < this.checkeds.length;
    }
    get hasStat() {
        return Object.keys(this.stats).length > 0;
    }
    get freezeColumns() {
        return this.frozenKeys.map((k) => this.columns.find((col) => col.key === k));
    }
    get unFreezeColumns() {
        return this.columns.filter((col) => this.frozenKeys.indexOf(col.key) === -1);
    }
    freezeColumn(key, freeze) {
        if (freeze) {
            if (this.frozenKeys.length >= 3) {
                this.$message.error(this.$t("cloudpivot.form.renderer.tip.frozenColumnMax"));
                return;
            }
            let width = 0;
            this.columns
                .map((col, i) => this.frozenKeys.indexOf(col.key) > -1 || col.key === key
                ? this.colStyles[i].width
                : 0)
                .forEach((w) => (width += parseInt(w)));
            if (width > 854) {
                this.$message.error(this.$t("cloudpivot.form.renderer.tip.frozenColumnWidthMax"));
                return;
            }
        }
        this.$emit("freezeColumn", key, freeze);
        if (!freeze) {
            setTimeout(() => {
                this.syncScrollLeft();
            }, 100);
        }
    }
    getFreezeCells(row) {
        return this.frozenKeys.map((k) => row.find((cell) => cell.key === k));
    }
    isLastFreeze(key) {
        return this.frozenKeys[this.frozenKeys.length - 1] === key;
    }
    isLastUnFreeze(key) {
        const cols = this.unFreezeColumns;
        let visibles = cols.filter(el => el.options.visible);
        return true;
        return cols[cols.length - 1].key === key || visibles[visibles.length - 1].key === key;
    }
    showColumn(key) {
        const index = this.columns.findIndex((c) => c.key === key);
        if (index < 0) {
            return false;
        }
        const col = this.columns[index];
        if (!col || !col.options.visible) {
            return false;
        }
        if (this.rows.length === 0) {
            return true;
        }
        const allHide = this.rows.every((row) => row[index].controller && !row[index].controller.display);
        return !allHide;
    }
    onColumnsChange() {
        this.initColStyleMap();
        this.$nextTick(() => {
            const el = this.$el.querySelector(".sheet__row:last-child > .sheet__cols");
            if (el) {
                this.sheetIsScroll = el.offsetWidth < el.scrollWidth;
            }
        });
    }
    onRowsChange() {
        this.$nextTick(() => {
            this.syncScrollLeft();
        });
    }
    checkAll(evt) {
        const checked = evt.target.checked;
        const checkeds = this.checkeds.map((c) => checked);
        this.$emit("check", checkeds);
        this.$emit("checkAll", checked);
    }
    check(idx) {
        const checked = this.checkeds[idx];
        let checkeds = this.checkeds.slice();
        if (this.radio) {
            checkeds = checkeds.map(() => false);
        }
        checkeds[idx] = !checked;
        this.$emit("check", checkeds, idx);
    }
    onScroll(evt) {
        this.syncScroll(evt.target);
    }
    syncScrollLeft() {
        if (!this.scrollbar) {
            this.scrollbar = this.$el.querySelector(".scrollbar");
            if (!this.scrollbar) {
                return;
            }
        }
        const el = this.scrollbar.querySelector(".sheet__cols");
        if (!el) {
            return;
        }
        this.syncScroll(el);
    }
    syncScroll(el) {
        // @ts-ignore
        if (document.activeElement.tagName === 'INPUT') {
            // @ts-ignore
            document.activeElement.blur();
        }
        this.shadowLeft = el.scrollLeft > 0;
        this.shadowRight = el.scrollLeft + el.offsetWidth < el.scrollWidth;
        if (NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (let i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
        const $sheetBody = this.$el.querySelector(".sheet__body");
        if (!$sheetBody) {
            return;
        }
        let _el = this.$el.querySelectorAll(".sheet__cols");
        for (let dv of _el) {
            if (dv !== el) {
                // dv.scrollLeft = el.scrollLeft - (el.scrollWidth - dv.scrollWidth);
                dv.scrollLeft = el.scrollLeft;
            }
        }
    }
    getErrorMessage(col, errCode) {
        return FormRendererHelper.getErrorMessage(col, errCode, this.$i18n.locale);
    }
    getControlClass(type) {
        return FormControlType[type].toLowerCase();
    }
    initColStyleMap() {
        this.colStyles = this.columns.map((col, colIdx) => {
            const last = colIdx === this.columns.length - 1;
            if (last && this.columns.length > 0) {
                const widths = this.columns.map((x) => x.width || 0);
                if (widths.length > 0) {
                    const totalWidth = widths.reduce((x, y) => x + y);
                    if (totalWidth < 885) {
                        return {};
                    }
                }
            }
            let width = col.width + "px";
            return {
                width,
            };
        });
    }
    onColResize(evt, colIdx, col) {
        const width = evt.width + "px";
        colIdx = this.columns.findIndex((c) => c.key === col.key);
        this.colStyles.splice(colIdx, 1, {
            width,
        });
        this.$emit("columnResize", {
            index: colIdx,
            column: col,
            width: evt.width,
        });
        // this.$forceUpdate();
    }
    getColStyle(key) {
        const index = this.columns.findIndex((c) => c.key === key);
        if (index < 0) {
            return {};
        }
        return this.colStyles[index];
    }
    getColumnStyle(col) {
        return col.options.style;
    }
    showStat(columnKey) {
        const s = this.stats[columnKey];
        if (!s) {
            return false;
        }
        return true;
    }
    getStatText(columnKey) {
        const s = this.stats[columnKey];
        if (!s) {
            return;
        }
        const opts = s.options;
        switch (opts.statisticMode) {
            case AggregateType.Sum:
                return this.$t("cloudpivot.form.renderer.label.sum");
            case AggregateType.Avg:
                return this.$t("cloudpivot.form.renderer.label.avg");
            case AggregateType.Min:
                return this.$t("cloudpivot.form.renderer.label.min");
            case AggregateType.Max:
                return this.$t("cloudpivot.form.renderer.label.max");
        }
    }
    // 求和
    getStats(columnKey) {
        const s = this.stats[columnKey];
        if (!s) {
            return;
        }
        if (this.originalRows.length === 0) {
            s.value = '';
            return s;
        }
        let rowsArr = [];
        this.originalRows.forEach((d) => {
            d.forEach((e) => {
                if (e.key === columnKey) {
                    rowsArr.push(e.controller.value ? e.controller.value : 0);
                }
            });
        });
        const opts = s.options;
        switch (opts.statisticMode) {
            case AggregateType.Sum:
                //因为前端控制了输入最大不会超过八位小数，所以这里可以这样处理求和精度问题
                rowsArr = rowsArr.map((item) => Math.pow(10, 10) * item);
                s.value = this.format(s, rowsArr.reduce(function (prev, curr) {
                    return prev + curr;
                }) /
                    Math.pow(10, 10));
                return s;
            case AggregateType.Avg:
                s.value = this.format(s, rowsArr.reduce(function (prev, curr) {
                    return prev + curr;
                }) / this.originalRows.length);
                return s;
            case AggregateType.Min:
                s.value = this.format(s, rowsArr.sort((a, b) => a - b)[0]);
                return s;
            case AggregateType.Max:
                s.value = this.format(s, rowsArr.sort((a, b) => a - b).reverse()[0]);
                return s;
        }
    }
    format(control, value) {
        control.value = value;
        const formatValue = numberFilter(control);
        if (control.options.format && control.options.format.includes("ratio") &&
            typeof formatValue === 'string' && value) {
            let val;
            if (control.options.isFlag) {
                val = this.numberToDisplay(this.accMul(value, 100), 'format', 'afterFormat1Change', control.options);
            }
            else {
                val = this.numberToDisplay(this.accMul(value, 100), 'format', 'beforeFormat1Change', control.options);
            }
            return val;
        }
        return formatValue;
    }
    accMul(arg1, arg2) {
        let numbers = arg1;
        let tmpVal = '' + arg1;
        let ee = tmpVal.replace(/[\d.-]/g, '');
        let rOpen = false;
        if (ee) {
            if (ee === 'E' || ee === 'e') {
                rOpen = true;
                let pos = tmpVal.indexOf('E');
                if (pos === -1) {
                    pos = tmpVal.indexOf('e');
                }
                let power = tmpVal.substr(pos + 1);
                if (power === '') {
                    let baseValue = tmpVal.substr(0, pos);
                    numbers = baseValue;
                    // 不调⽤Number函数了，防⽌转换为科学计数法了
                }
                else {
                    let baseValue = tmpVal.substr(0, pos);
                    let character = power.substr(0, 1);
                    if (character === '-') {
                        let times = power.substr(1);
                        if (times === '' || times === '0') {
                            numbers = baseValue;
                            // 不调⽤Number函数了，防⽌转换为科学计数法了
                        }
                        else {
                            times = Number(times);
                            let baseValueLength = baseValue.length;
                            let floatLength = baseValue.indexOf('.') + 1;
                            let length = baseValueLength - floatLength;
                            numbers = arg1.toFixed(length + times);
                            if (numbers) {
                                numbers = numbers.substr(numbers.lastIndexOf(".") + 3, numbers.length);
                                numbers = '0.' + numbers;
                            }
                            // 这⾥只能以字符串形式输出了，不能再调⽤Number函数
                        }
                    }
                    else {
                        let powerVal = Math.pow(10, power);
                        numbers = baseValue * powerVal;
                    }
                }
            }
        }
        arg1 = numbers;
        var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
        try {
            m += s1.split(".")[1].length;
        }
        catch (e) { }
        try {
            m += s2.split(".")[1].length;
        }
        catch (e) { }
        return rOpen ? arg1 : Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    }
    numberToDisplay(value, filed, type, controlOpts) {
        let result = value;
        if (type === 'afterFormat1Change') {
            switch (controlOpts[filed]) {
                case 'ratio.percentile':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 0,
                    });
                    break;
                case 'ratio.Millimeter':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 1,
                    });
                    break;
                case 'ratio.tenThousand':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 2,
                    });
                    break;
                case 'ratio.hundredThousand':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 3,
                    });
                    break;
                case 'ratio.millionDecimals':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 4,
                    });
                    break;
                case 'ratio.tenMillionDecimals':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 5,
                    });
                    break;
                case 'ratio.billionDecimals':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 6,
                    });
                    break;
            }
        }
        else {
            switch (controlOpts[filed]) {
                case 'ratio':
                case 'ratio':
                case 'ratio':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 0,
                    });
                    break;
                case 'ratio.tenths':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 1,
                    });
                    break;
                case 'ratio.percentile':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 2,
                    });
                    break;
                case 'ratio.Millimeter':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 3,
                    });
                    break;
                case 'ratio.tenThousand':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 4,
                    });
                    break;
                case 'ratio.hundredThousand':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 5,
                    });
                    break;
                case 'ratio.millionDecimals':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 6,
                    });
                    break;
                case 'ratio.tenMillionDecimals':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 7,
                    });
                    break;
                case 'ratio.billionDecimals':
                    result = numberFormatter.ratio.formatter(result, {
                        precision: 8,
                    });
                    break;
            }
        }
        return result;
    }
    getColumnLabel(col) {
        const label = col.options.name;
        const locale = this.$i18n.locale;
        const name_i18n = col.options.name_i18n;
        if (locale && name_i18n) {
            const locales = typeof name_i18n === "string" ? JSON.parse(name_i18n) : name_i18n;
            if (locales[locale]) {
                return locales[locale];
            }
        }
        return label;
    }
    getColumnRequired(col) {
        let item = this.columnOptions.find((val) => val.key === col.key);
        if (item) {
            return !!item.options.required;
        }
        else {
            return false;
        }
    }
    getTips(col) {
        const { tips } = col.options;
        return tips;
    }
    handleRootScroll() {
        if (!this.scrollbar) {
            this.scrollbar = this.$el.querySelector(".scrollbar");
            if (!this.scrollbar) {
                return;
            }
        }
        const $sheet = this.$el.querySelector(".sheet");
        if (!$sheet) {
            return;
        }
        const $sheetBody = $sheet.querySelector(".sheet__body");
        if (!$sheetBody) {
            return;
        }
        const sheetRect = $sheet.getBoundingClientRect();
        const bodyRect = $sheetBody.getBoundingClientRect();
        const clientHeight = document.documentElement.clientHeight;
        const over = sheetRect.top + sheetRect.height + this.scrollbar.offsetHeight >
            clientHeight;
        if (bodyRect.top < clientHeight && over) {
            this.scrollbar.style.width = $sheet.offsetWidth + "px";
            this.scrollbar.classList.add("stick");
        }
        else {
            this.scrollbar.classList.remove("stick");
        }
    }
    created() {
        this.mounteStartTime = Date.now();
    }
    mounted() {
        this.$nextTick(() => {
            // console.log('======mounted use time:', Date.now() - this.mounteStartTime);
            this.setMaxHeight();
            const el = this.$el.querySelector(".sheet__row:last-child > .sheet__cols");
            if (el) {
                this.shadowRight = el.offsetWidth < el.scrollWidth;
                // this.sheetIsScroll = this.shadowRight;
            }
            this.handleRootScroll();
            this.onScrollFn = () => {
                this.handleRootScroll();
            };
            if (this.getScrollEl) {
                const scrollEl = this.getScrollEl();
                if (scrollEl) {
                    scrollEl.addEventListener("scroll", this.onScrollFn);
                }
            }
        });
        window.addEventListener("resize", this.setMaxHeight);
    }
    beforeUpdate() {
        this.updateStartTime = Date.now();
    }
    destroyed() {
        if (this.getScrollEl && this.onScrollFn) {
            const scrollEl = this.getScrollEl();
            if (scrollEl) {
                scrollEl.removeEventListener("scroll", this.onScrollFn);
            }
        }
        window.removeEventListener("resize", this.setMaxHeight);
    }
    // 设置最大高度,表单内容超过最大高度滚动。
    setMaxHeight() {
        //节流
        let setTimeoutHander = setTimeout(() => {
            clearTimeout(setTimeoutHander);
            let maxHeight = document.body.clientHeight -
                document.querySelector(".form-detail>.header")
                    .offsetHeight -
                150;
            maxHeight = maxHeight < 100 ? 100 : maxHeight;
            this.sheetBodyStyle = {
                maxHeight: maxHeight + "px",
            };
        }, 500);
    }
};
tslib_1.__decorate([
    Prop({
        default: 0,
    })
], Sheet.prototype, "rowNumber", void 0);
tslib_1.__decorate([
    Prop({
        default: false,
    })
], Sheet.prototype, "checkbox", void 0);
tslib_1.__decorate([
    Prop({
        default: false,
    })
], Sheet.prototype, "radio", void 0);
tslib_1.__decorate([
    Prop({
        default: false,
    })
], Sheet.prototype, "showAction", void 0);
tslib_1.__decorate([
    Prop({
        default: false,
    })
], Sheet.prototype, "showTotal", void 0);
tslib_1.__decorate([
    Prop({
        default: () => [],
    })
], Sheet.prototype, "columns", void 0);
tslib_1.__decorate([
    Prop({
        default: () => [],
    })
], Sheet.prototype, "columnOptions", void 0);
tslib_1.__decorate([
    Prop({
        default: () => [],
    })
], Sheet.prototype, "removeList", void 0);
tslib_1.__decorate([
    Prop({
        default: () => [],
    })
], Sheet.prototype, "frozenKeys", void 0);
tslib_1.__decorate([
    Prop({
        default: () => ({}),
    })
], Sheet.prototype, "columnSlots", void 0);
tslib_1.__decorate([
    Prop({
        default: () => [],
    })
], Sheet.prototype, "rows", void 0);
tslib_1.__decorate([
    Prop({
        default: () => [],
    })
], Sheet.prototype, "originalRows", void 0);
tslib_1.__decorate([
    Prop({
        default: () => ({}),
    })
], Sheet.prototype, "rowSlots", void 0);
tslib_1.__decorate([
    Prop({
        default: () => [],
    })
], Sheet.prototype, "checkeds", void 0);
tslib_1.__decorate([
    Prop({
        default: -1,
    })
], Sheet.prototype, "checked", void 0);
tslib_1.__decorate([
    Prop({
        default: () => ({}),
    })
], Sheet.prototype, "stats", void 0);
tslib_1.__decorate([
    Inject()
], Sheet.prototype, "getScrollEl", void 0);
tslib_1.__decorate([
    Watch("columns", {
        immediate: true,
    })
], Sheet.prototype, "onColumnsChange", null);
tslib_1.__decorate([
    Watch("rows", {
        immediate: true,
    })
], Sheet.prototype, "onRowsChange", null);
Sheet = tslib_1.__decorate([
    Component({
        name: "sheet",
        components: {
            AIcon: Icon,
            APopover: Popover,
            ADivider: Divider,
            AButton: Button,
            ACheckbox: Checkbox,
            ADropdown: Dropdown,
            ATooltip: Tooltip,
            AMenu: Menu,
            AMenuItem: Menu.Item,
            BaseControlAdapter,
            H3SizeSlider: common.components.H3SizeSlider,
            CheckboxText,
        },
        filters: {
            number: numberFilter,
        },
    })
], Sheet);
export default Sheet;
